// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DangerBtn_danger-btn__9hD7o {
  border: 0.2rem solid var(--danger);
  border-radius: 0.8rem;
  color: var(--danger);
  font-size: var(--text-base);
  font-weight: 500;
  transition: background-color 0.3s ease-out;
}

.DangerBtn_danger-btn__9hD7o:hover {
  background-color: var(--danger);
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/components/UI/DangerBtn/DangerBtn.module.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,+BAA+B;EAC/B,WAAW;AACb","sourcesContent":[".danger-btn {\n  border: 0.2rem solid var(--danger);\n  border-radius: 0.8rem;\n  color: var(--danger);\n  font-size: var(--text-base);\n  font-weight: 500;\n  transition: background-color 0.3s ease-out;\n}\n\n.danger-btn:hover {\n  background-color: var(--danger);\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"danger-btn": `DangerBtn_danger-btn__9hD7o`
};
export default ___CSS_LOADER_EXPORT___;
